export default __webpack_public_path__ + "static/6822-8ad370e496ce8bf768c94fb9337ae2fe.jpg";